<template>
	<Layout>
		<div class="container">
			<h3 class="fav fw-semibold">Favorites</h3>
		</div><br><br>

		<div class="container-sm favourites">
			<div class="row" v-if="favorites.length">
				<div class="col-xl-6 col-lg-8 col-md-12 " v-for = "(favorite) in favorites" :key="favorite.fav_id" >
					<!-- <div class="card mb-3"  style="box-shadow: 0px 0px 2px 0px rgba(16, 16, 16, 0.63); background-color: rgb(245, 244, 244);">
						<div class="row g-0">
							<div class="col-md-2 imgbox" v-if = "favorite.product_image">
								<img :src="$image_url + favorite.product_image" class="img-fluid rounded-start" alt>
                           
							</div>
							<div class="col-md-2 imgbox" v-else>
								<img src="/design/sigofood-images/chicken-burger.png" class="img-fluid rounded-start" alt>
							</div>
							<div class="col-md-10">
								<div class="card-body">
									<div class="row">
										<div class="col">
											<h5 class="card-title">{{favorite.product_name}}</h5>
										</div>
										<div class="col-2 d-flex">
											<img src="/design/sigofood-images/share.png" alt="share" style="height:18px; width:18px; margin-right: 10px;">

											<div v-if="favorite.fav_id">
												<img src="/design/sigofood-images/favorite.png" @click="removeFavorite(favorite.fav_id)" alt="share"
												style="height:18px; width:18px;  margin-right: 1px;">
											</div>
										</div>
									</div>
									<div v-if="favorite.description">
										<p class="card-text"><small class="text-muted">{{favorite.description}}</small></p>
									</div>
									<div v-else>
										<p class="card-text"><small class="text-muted">No description available</small></p>
									</div>
									
									<button class="price">BHD {{favorite.price}}</button>

								</div>
							</div>
						</div>
					</div> -->
					<div class="card mb-3"  style="box-shadow: 0px 0px 2px 0px rgba(16, 16, 16, 0.63); background-color: rgb(245, 244, 244);">
                  <div class="row g-0">
                     <div class="col-lg-9 d-flex">
                        <div class="imgbox">      
                           <div v-if="favorite.product_image" :style="{ 'background-image': 'url(' + $image_url + favorite.product_image + ')' }" ></div>
                           <div v-else :style="{ backgroundImage: `url(${NoImageUrl})` }" ></div>
                     	</div>
                                            
                        <div class="col p-3">
                           <h5 class="card-title">{{favorite.product_name}}</h5>
                           <div v-if="favorite.description">
										<p class="card-text"><small class="text-muted">{{favorite.description}}</small></p>
									</div>
									<div v-else>
										<p class="card-text"><small class="text-muted">No description available</small></p>
									</div>
									
									<button class="price">BHD {{favorite.price}}</button>
                        </div>
                     </div>

                     <div class="col-lg-3 p-3">
                        <div class="col add-favourite">
                        	<img src="/design/sigofood-images/share.png" alt="share" style="height:18px; width:18px; margin-right: 10px;">

											<div v-if="favorite.fav_id">
												<img src="/design/sigofood-images/favorite.png" @click="removeFavorite(favorite.fav_id)" alt="share"
												style="height:18px; width:18px;  margin-right: 1px;">
											</div>                        
                        </div>
                     </div>
                  </div>
               </div>
				</div>
			</div>
			<div class="row" v-else>
				<div class="col-12 text-center">
					<p>No favourites found!</p>
				</div>
			</div>
		</div>

		<br>
		
	</Layout>
</template>

<script>
// @ is an alias to /src
import Layout from "@/layout/Main.vue";
import NoImageUrl from "@/assets/no-image.png";

export default {
	 components: {
		  Layout
	 },

	 data () {
		return {
		NoImageUrl,
		publicPath: process.env.BASE_URL,
		style: null,
		device_token:'',
		uid:'',
		token:'',


		  favorites: [],

		}
	 },
	 created() {
		  //alert(this.publicPath);

		  this.style = document.createElement('link')
		  this.style.setAttribute('rel', 'stylesheet')
		  this.style.setAttribute('href', '/design/favorites.css')
		  document.head.appendChild(this.style)
		  this.getToken();

	 },

	 beforeDestroy() {
		document.head.removeChild(this.style);
	},
	 mounted() {
         this.fetchFavorite();
      },
	 methods:{
		getToken() {
         if (localStorage.getItem('sigofood_user')) {
            var sigofood_user =  JSON.parse(localStorage.getItem('sigofood_user'));
			console.log(sigofood_user);
            if(sigofood_user.token) {
               this.token = sigofood_user.token;
			   this.uid = sigofood_user.uid;
			   this.user_id = sigofood_user.user_id;
			   console.log(this.token);
			   console.log(this.uid);
			   console.log(this.user_id);

            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
               
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
      }, 
		fetchFavorite(){
				
				this.getToken();
				let url = "favourites/get?uid=" +this.uid;
	
				this.loading = true;
				
				this.$axios
				   .get(url, { headers: { Authorization: "Bearer " + this.token } })
				   .then((res) => {
					  if(res.status == 200) {
						 var responseData = res.data.data;
						 console.log(responseData);
						 this.favorites = responseData;
						
						 console.log(this.favorites);
					  } else {
						 this.$swal("", "Something went wrong", "error");
					  }
				})
				.catch((error) => {
				   if (error.response) {
					  if(error.response.status == 422) {               
						 if (error.response.data) {
							this.errors = error.response.data.message;
						 } 
						 this.$swal("", error.response.statusText, "error");
						 
					  } else if(error.response.status == 500) {
						 this.$swal("", error.response.statusText, "error");
	
					  } else if(error.response.status == 401) {
						 this.$swal("", error.response.statusText, "error");
						 this.$router.push({ name: "login" });
						 
					  } else {
						 this.$swal("", "Something went wrong", "error");
					  }
				   } else {
					  this.$swal("", error.message, "error");
				   }
				})
				.finally(() => (this.loading = false));
			},
			removeFavorite(favourite_id){
			const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,

               },
            };
               let url = "favourites/remove";          
			   let formData = new FormData(); 
               formData.append("favourite_id", favourite_id);
			   formData.append("uid", this.uid);
               this.$axios
                  .post(url,formData, config)
                  .then((res) => {
                     if(res.status == 200) {
                this.$swal("", res.data.message, "success");        
				this.$router.go(0);
            //    this.hideModal('fuel-modal');
            //    this.fetchFuels(this.active_page_url);
                     } else {
                        this.$swal("", "Something went wrong", "error");
						console.log(this.error);
                     }
                  
               })
               .catch((error) => {
                  if (error.response) {
                     if(error.response.status == 422) {               
                        if (error.response.data) {
                           this.errors = error.response.data.message;
                        } 
                        this.$swal("", error.response.statusText, "error");
                        
                     } else if(error.response.status == 500) {
                        this.$swal("", error.response.statusText, "error");

                     } else if(error.response.status == 401) {
                        this.$swal("", error.response.statusText, "error");
                        this.$router.push({ name: "login" });
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", error.message, "error");
                  }
               })
               .finally(() => (this.loading = false));
		}
	 },

}
</script>
